module.exports = __webpack_public_path__ + "static/img/partner_Karinna.1921bb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/timemaria/partner_Karinna.jpg
// module id = pCUk
// module chunks = 1